import { render, staticRenderFns } from "./Productions.vue?vue&type=template&id=ceff8736&scoped=true&"
import script from "./Productions.vue?vue&type=script&lang=js&"
export * from "./Productions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceff8736",
  null
  
)

export default component.exports